import Vue from 'vue'

Vue.directive('focus', {
  inserted(el, binding) {
    if (!binding.value) return
    el.focus()
  },
})
